import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import { SupabaseListUserFeedbackRepository } from '@/modules/feedback/infra'
import type { ListUserFeedback } from '@/modules/feedback/use-cases'

export function makeListUserFeedback(): ListUserFeedback {
  return new SupabaseListUserFeedbackRepository(makeSupabaseEdgeHttpClient()).execute
}
